var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm._m(0),
    _vm._m(1),
    _vm._m(2),
    _vm._m(3),
    _c("div", { staticClass: "y-pl-20" }, [
      _vm._v(" 集运仓入库后将重新打包，并将包裹转运至消费者实际地址 "),
    ]),
    _vm._m(4),
    _c("div", { staticClass: "y-pl-20" }, [
      _vm._v(
        " 若您需要查看消费者信息/中转状态/最新二段物流轨迹，请前往拼多多商家后台"
      ),
      _c(
        "a",
        {
          staticClass: "y-fc-4C84FF",
          attrs: {
            href:
              "https://mms.pinduoduo.com/orders/detail?type=4399&sn=" +
              _vm.orderId,
            target: "_blank",
          },
        },
        [_vm._v("查看订单详情")]
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "y-fs-16 y-fw-700 y-fl-32" }, [
      _vm._v(" 集运订单请直接发货至集运仓库"),
      _c("span", { staticClass: "y-fs-12 y-fc-999" }, [
        _vm._v("（详细信息请"),
        _c(
          "a",
          {
            staticClass: "y-fc-4C84FF",
            attrs: {
              href: "https://mms.pinduoduo.com/daxue/detail?courseId=5460",
              target: "_blank",
            },
          },
          [_vm._v("查看课程")]
        ),
        _vm._v("）"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "y-mt-5 y-fs-14 y-fw-700" }, [
      _c("i", { staticClass: "el-icon-check y-fc-3bb950 y-fs-16" }),
      _vm._v(" 商家直接发货至集运仓库 "),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "y-pl-20" }, [
      _vm._v(" 订单收件人信息已替换为集运仓地址，打单发货时请"),
      _c("span", { staticClass: "y-fc-FE8732" }, [
        _vm._v("复制完整的收货信息（包括地址后识别码）"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "y-mt-5 y-fs-14 y-fw-700" }, [
      _c("i", { staticClass: "el-icon-check y-fc-3bb950 y-fs-16" }),
      _vm._v(" 集运仓库二次发货至消费者 "),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "y-mt-5 y-fs-14 y-fw-700" }, [
      _c("i", { staticClass: "el-icon-check y-fc-3bb950 y-fs-16" }),
      _vm._v(" 消费者信息/中转状态/二段轨迹信息查看请移步至商家后台 "),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }